// extracted by mini-css-extract-plugin
export default {"modal":"ImageEditor_modal__Fgw2Z"};